const RequestHandler = (formData, name, type, logoPath, includeCompanyId = false, user) => {
    const valuesArray = Object.entries(formData).map(([key, value]) => ({
        name: key,
        value: value,
    }));

    if (logoPath) {
        valuesArray.push({
            name: "company logo",
            value: logoPath,
        });
    }

    const requestData = {
        data: {
            name: name,
            type: type,
            value: valuesArray,
        },
    };

    if (includeCompanyId) {
        const companyId = user.company_id;
        requestData.data.company_id = companyId;
    }

    return requestData;
};

export default RequestHandler;
